import { jsx as _jsx } from "react/jsx-runtime";
import BaseCircularProgress from './CircularProgress.styled';
function CircularProgress({ progress, size = 36, ...otherProps }) {
    return (_jsx(BaseCircularProgress, { size: size, value: progress, ...otherProps }));
}
export default CircularProgress;
